<template>
    <component :is="customTag ?? 'span'" v-if="enableSmartLinks" :data-kontent-element-codename="codename">
        <slot></slot>
    </component>
    <template v-else>
        <component :is="customTag ?? 'span'">
            <slot></slot>
        </component>
    </template>
</template>
<script setup lang="ts">
const props = defineProps<{ codename: string, customTag?: string }>()
const enableSmartLinks = useRuntimeConfig().public.enableSmartLinks
</script>